import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Utils from "models/helper/Utils";
import ti18n from "i18n!nls/QueueOptionMenui18n";
import popupTemplate from 'text!../../../templates/queueOptionMenu/QueueOptionMenuPopup.html';

const QueueOptionMenuView = Backbone.View.extend({

    template : _.template(popupTemplate),

    "pageName" : "Queue Menu",

    initialize : function(options) {
        
    },


    events : {
        "click #emptyQueueBtn" : "emptyQueue",
        "click #saveAsPlaylistBtn" : "saveAsPlaylist",	
        "click #closeBtn" : "_close"
    },

    emptyQueue : function(){
        this._close();
        this.trigger("emptyQueue", this.model);
    },
    
    _close : function(){
        this.$el.popup('close');
    },

    saveAsPlaylist : function(){
        this._close();
        this.trigger("saveAsPlaylist", this.model);	
    },
    

    

    render : function() {
        this.$el.html(this.template({"model":this.model, "ti18n": ti18n}));
        this.setElement(this.$el.find("div").first());
        const elementId = this.$el.attr('id');
        this.$el.on({
            popupbeforeposition: (function() {
                // const maxHeight = $( window ).height() - 60 + "px";
                const width = $( window ).width() - 0 + "px";
                // this.$el.css( "height", maxHeight );
                this.$el.css( "width", width );
            }).bind(this)
        });
        this.$el.on({
            popupafterclose: (function() {
                this.remove();
                this.undelegateEvents();
                
            }).bind(this)});
        $.mobile.pageContainer.prepend(this.$el);
        this.$el.popup({transition:"fade", dismissible: false,  tolerance: "0,0"});
        if(elementId)
        {
            const screenPopup$el = $("#"+elementId + "-screen");
            $.mobile.pageContainer.remove("#"+elementId + "-screen");
            $.mobile.pageContainer.prepend(screenPopup$el);
        }
        
        this.$el.enhanceWithin();
        Utils.getInstance().closeCurrentJQMPopup().then((function(){
            this.$el.popup('open' );
        }).bind(this));
        return this;
    }

});

export default QueueOptionMenuView;